// extracted by mini-css-extract-plugin
export default {"container":"TagPage_container__XyvkL","textContainer":"TagPage_textContainer__i4C4Q","productCard":"TagPage_productCard__NGhYC"};